import "@/components/Footer/Footer.css";
import { Box } from "@mui/material";

function Footer() {
  return <Box id="footer"></Box>;
}

export default Footer;
